/**
 * Converts font size in pixels to rem-units
 * @param {number} px Font size in pixels
 * @param {number} [base=16] Optional reference size
 * @returns {string} Value in rem-units
 */
const rem = (px: number, base = 16) => `${px / base}rem`;

export { rem };
